module.exports = __webpack_public_path__ + "img/user_male.fb329f10.svg";